export const SALES_GET_LIST = "SALES_GET_LIST";
export const SALES_UPDATE_FILTER = "SALES_UPDATE_FILTER";